import { createFileRoute, redirect } from '@tanstack/react-router'
import RecycleBinView from '@preferences/admin/RecycleBinView'

export const Route = createFileRoute('/_auth/preferences/recycle')({
  component: RouteComponent,
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (!scopedEnablements.global().hasStandardEnablement('RecycleBin', 'MANAGE')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  return <RecycleBinView />
}
